import React, { useEffect, useState } from 'react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { useDispatch, useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { fetchTermsConditions, postTermsConditions } from '../../Redux/Reducers/TermsConditionsReducer';
import { usePermissions } from '../../context/AuthContext';

export const TermsAndCondition = () => {
    const { can } = usePermissions();
    const dispatch = useDispatch();
    const { content, status, error } = useSelector((state) => state.TermsConditionsReducer || {});
    const [data, setData] = useState("");

    useEffect(() => {
        dispatch(fetchTermsConditions());
    }, [dispatch]);

    useEffect(() => {
        if (content) {
            setData(content || "");
        }
    }, [content]);

    const handlePostTermsConditions = (e) => {
        e.preventDefault();
        dispatch(postTermsConditions({ key: "terms_conditions", title: "Terms and Conditions", content: data }))
            .unwrap()
            .then(() => {
                toast.success("Terms and Conditions content saved successfully!");
            })
            .catch((err) => {
                toast.error(err.message || "Failed to save Terms and Conditions content.");
            });
    };

    const handleTextChange = (event, editor) => {
        const text = editor?.getData();
        setData(text);
    };

    return (
        <>
            <div className="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0">
                <h3 className="mb-0 fw-bold">Terms and Conditions</h3>
            </div>
            <hr />
            <div className="card-body">
                <form>
                    <div className="row g-3 align-items-center">
                        <div className="col-md-12">
                            <CKEditor
                                editor={ClassicEditor}
                                data={data}
                                config={{
                                    toolbar: [
                                        "heading",
                                        "|",
                                        "bold",
                                        "italic",
                                        "link",
                                        "bulletedList",
                                        "numberedList",
                                        "|",
                                        "blockQuote",
                                        "insertTable",
                                        "|",
                                        "undo",
                                        "redo"
                                    ],
                                    placeholder: "Enter Terms and Conditions content here..."
                                }}
                                onChange={handleTextChange}
                                disabled={!can('terms_conditions:edit')}
                            />
                        </div>
                    </div>
                    <br />
                    <div className="d-flex justify-content-end">
                        {can('terms_conditions:edit') && (
                            <button
                                type="submit"
                                onClick={handlePostTermsConditions}
                                className="btn btn-primary btn-set-task w-sm-100 text-uppercase px-5"
                                disabled={status === 'loading'}
                            >
                                {status === 'loading' ? 'Saving...' : 'Save'}
                            </button>
                        )}
                    </div>
                </form>
            </div>
        </>
    );
};

export default TermsAndCondition;